__turbopack_context__.v({
  "className": "gtwalsheim_7c02206-module__jFhCvq__className",
  "variable": "gtwalsheim_7c02206-module__jFhCvq__variable",
});
